import * as Connector from 'shared/connectors/partnerConnector';
import { PARTNER } from 'store/types';

const init = () => ({
  type: PARTNER.GET_PARTNERS_INIT,
});

export const success = data => ({
  type: PARTNER.GET_PARTNERS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: PARTNER.GET_PARTNERS_FAILURE,
});

const getPartners = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getPartners();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getPartners;
